import type { ApiPlacesResponseGet } from 'www/vue_components/common/TheFilters/lpu/api/apiMetrosAndDistricts.types'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

function mapPlace(
  place: ApiPlacesResponseGet['metro'][number] | ApiPlacesResponseGet['district'][number],
  isMetro: boolean,
): NonNullable<Filters['place']> {
  return {
    id: place.id,
    name: place.name,
    translit: place.translit,
    townRedirect: place.town_redirect,
    isMetro,
  }
}

export default mapPlace
